import { Suspense, lazy } from 'react';

import { MaasGroupsConfigSection } from './groups-config-section';
import type { MaasNodeGroupsBlockProps } from './types';

const MiInferenceNodeGroupsBlock = lazy(() =>
  import('@/delivery-type-plugin/plugins/ModelInstance/ui/MiInferenceNodeGroupsBlock').then((m) => ({
    default: m.MiInferenceNodeGroupsBlock,
  })),
);

/** 模型实例节点组配置能力块 */
export function MaasNodeGroupsBlock({ form, options }: MaasNodeGroupsBlockProps) {
  if (options?.nodeGroupVariant === 'modelInstance') {
    return (
      <Suspense fallback={null}>
        <MiInferenceNodeGroupsBlock form={form} options={options} fieldPaths={options?.fieldPaths} />
      </Suspense>
    );
  }
  return (
    <MaasGroupsConfigSection
      form={form}
      namespace={options?.namespace}
      isEdit={options?.isEdit}
      initValues={options?.initValues}
      typeOptions={options?.typeOptions}
      billModelId={options?.billModelId}
      deploymentTypeId={options?.deploymentTypeId}
      paymentTiming={options?.paymentTiming}
      skuType={options?.skuType}
      resourceEditMode={options?.resourceEditMode}
      lockActionsWhenFilled={options?.lockActionsWhenFilled}
      initCommandScriptHint={options?.initCommandScriptHint}
      initCommandSectionDesc={options?.initCommandSectionDesc}
      startupCommandSectionDesc={options?.startupCommandSectionDesc}
      initCommandEditor={options?.initCommandEditor}
      showNodeStartupCommand={options?.showNodeStartupCommand}
      showInstanceReplicas={options?.showInstanceReplicas}
      getDefaultGroupName={options?.getDefaultGroupName}
      masterGroupTitle={options?.masterGroupTitle}
      masterGroupRoleLabel={options?.masterGroupRoleLabel}
      onRunModeChange={options?.onRunModeChange}
      embeddedNodeConfig={options?.embeddedNodeConfig}
      showInferenceFramework={options?.showInferenceFramework}
      showTrainingImage={options?.showTrainingImage}
      showService={options?.showService}
      showHealthCheck={options?.showHealthCheck}
      showAdvancedConfig={options?.showAdvancedConfig ?? options?.showHealthCheck}
      showNic={options?.showNic}
      customImageOnly={options?.customImageOnly}
      presetArchitecture={options?.presetArchitecture}
      presetImageLocked={options?.presetImageLocked}
      nicPricingOptions={options?.nicPricingOptions}
      requireGpuSoftware={options?.requireGpuSoftware}
      fieldPaths={options?.fieldPaths}
      sectionTitle={options?.sectionTitle}
    />
  );
}
